if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends HTMLElement {
    constructor() {
      super();

      this.mainDetailsToggle = this.querySelector('details');
      this.elements = {
        shareButton: this.querySelector('button'),
        shareSummary: this.querySelector('summary'),
        closeButton: this.querySelector('.share-button__close'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input')
      }
      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

      if (!this.mainDetailsToggle) return;

      if (navigator.share && this.elements.shareButton) {
        this.mainDetailsToggle.setAttribute('hidden', '');
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', () => { navigator.share({ url: this.urlToShare, title: document.title }) });
      } else {
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__copy')?.addEventListener('click', this.copyToClipboard.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__close')?.addEventListener('click', this.close.bind(this));
      }
    }

    toggleDetails() {
      if (!this.mainDetailsToggle.open) {
        this.elements.successMessage?.classList.add('hidden');
        if (this.elements.successMessage) this.elements.successMessage.textContent = '';
        this.elements.closeButton?.classList.add('hidden');
        this.elements.shareSummary?.focus();
      }
    }

    copyToClipboard() {
      if (!this.elements.urlInput) return;
      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        this.elements.successMessage?.classList.remove('hidden');
        if (this.elements.successMessage) this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
        this.elements.closeButton?.classList.remove('hidden');
        this.elements.closeButton?.focus();
      });
    }

    close() {
      this.mainDetailsToggle?.removeAttribute('open');
      this.elements.shareSummary?.setAttribute('aria-expanded', 'false');
      this.elements.shareSummary?.focus();
    }

    updateUrl(url) {
      this.urlToShare = url;
      if (this.elements.urlInput) this.elements.urlInput.value = url;
    }
  });
}
